import { render, staticRenderFns } from "./DepartmentDialog.vue?vue&type=template&id=ae3ba396"
import script from "./DepartmentDialog.vue?vue&type=script&lang=js"
export * from "./DepartmentDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports